<div class="are-you-sure-content-container">
  <div class="mat-headline-4 are-you-sure-text-container">
    {{ 'All progress' | translate }}
  </div>
  <div class="are-you-sure-button">
    <app-action-button
      kind="filled"
      color="primary"
      size="extra-wide"
      (onClick)="close('cancel')"
      >{{ 'Yes, cancel' | translate }}
    </app-action-button>
  </div>
  <div class="are-you-sure-button">
    <app-action-button
      kind="outline"
      color="primary"
      size="extra-wide"
      (onClick)="close('continue')"
      >{{ 'No, continue editing' | translate }}
    </app-action-button>
  </div>
</div>
